// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"272a9837","247":"5b5e22c3","256":"34d56c1b","287":"5f1869d8","365":"535bda67","422":"92e33d7d","475":"8f9a19e8","536":"b1bec62e","617":"45bd29d3","627":"59263c34","768":"feeb2888","834":"b5d6505c","867":"4c216a4d","923":"13b225f3","938":"43beac47"}[chunkId] + ".chunk.js";
};